// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3PUtt","fileBtn":"File_fileBtn__1xita","closeBtn":"File_closeBtn__2Ddea","fileSelected":"File_fileSelected__3FfGf","disabled":"File_disabled__vf9gj"};